var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16833_268640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 26V34H20V26H14L24 16L34 26H28ZM38.7 20.06C38.0241 16.6591 36.1894 13.598 33.5087 11.3988C30.828 9.19951 27.4674 7.9983 24 8C18.22 8 13.2 11.28 10.7 16.06C7.75877 16.3823 5.04008 17.7792 3.06541 19.9827C1.09075 22.1862 -0.000849857 25.0412 4.96443e-07 28C4.96443e-07 31.1826 1.26428 34.2348 3.51472 36.4853C5.76516 38.7357 8.8174 40 12 40H38C39.3132 40 40.6136 39.7413 41.8268 39.2388C43.0401 38.7363 44.1425 37.9997 45.0711 37.0711C45.9997 36.1425 46.7362 35.0401 47.2388 33.8268C47.7413 32.6136 48 31.3132 48 30C48 24.72 43.9 20.44 38.7 20.06Z",
    fill: "#919699"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16833_268640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.c7c0a0038b47efb7bf52f685026cfcc4.svg";
export { ForwardRef as ReactComponent };